






















import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import dayjs from '@/node_modules/dayjs'

@Component
export default class ModalDatePicker extends ComponentVue {
  @Prop({ type: String, default: '' })
  inputDate!: string

  @Prop({
    type: Boolean,
    default: false
  })
  inheritPickerDate!: boolean

  currentDate: string = dayjs().format('YYYY-MM')

  date: string = new Date().toISOString().substr(0, 10)

  dialog: boolean = false

  @Emit('opened')
  opened(): void {
    console.log('ModalDatePicker - opened')
  }

  @Emit('closed')
  closed(): void {
    console.log('ModalDatePicker - closed')
  }

  @Emit('click:date')
  onInput(): void {
    this.close()
  }

  open(): void {
    this.dialog = true
    this.currentDate =
      this.inputDate !== ''
        ? dayjs(this.inputDate).format('YYYY-MM')
        : this.currentDate
  }

  close(): void {
    this.dialog = false
    this.currentDate = this.inheritPickerDate
      ? this.currentDate
      : dayjs().format('YYYY-MM') // デフォルト：表示初期位置 → 現在日時
  }

  updatePickerDate(value: string): void {
    this.currentDate = value
  }
}
